<template>
  <div id="settings-login" class="page valign-wrapper">
    <div class="wrapper">
      <Login v-if="$store.getters.platform !== 'browser'" :title="$t('SETTINGS.LOGIN')" />
    </div>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Login from '@/components/Login'

export default {
  name: 'SettingsLogin',
  components: { Login },
  created: function () {
    // si el usuario esta logeado cargamos contenidos
    if (this.$store.getters.platform === 'browser') {
      this.$router.replace({name: 'login-browser'})
    }
  },
  mounted: function () {
    // keys control
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    keyBack () { this.$router.go(-1) }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#settings-login

  .wrapper
    margin: auto
    background-color: #ffffff
    color: #424242
</style>



// WEBPACK FOOTER //
// src/pages/settings/Login.vue